
function scrollToAnchor(id) {
  var tag = $("#" + id);
  if ($(window).width() > 850) {
    $("html,body").animate({ scrollTop: tag.offset().top }, 1500);
  } else {
    $("html,body").animate({ scrollTop: tag.offset().top }, 1500);
  }
}

$(".loader").show();
$("body").jpreLoader(
  {
    showPercentage: true,
    preMainSection: ".loader",
    prePerText: "span",
    preBar: "",
  },
  function() {
    $("html, body").scrollTop(0);

    new WOW({
      boxClass: "wow",
      offset: 0,
      mobile: true,
      live: true,
    }).init();

    if (
      typeof app == "object" &&
      typeof app._section == "object" &&
      app._section !== null &&
      typeof app._section.initSliderHome == "function"
    ) {
      typeof app._section.initSliderHome();
    }
    //		heroSlider = window.heroSlider || false;
    //		if (heroSlider) heroSlider.startAuto();
    setTimeout(function() {
      $("body").addClass("stopAnimation");
    }, 6000);

    $("[img-cache-bg]").each(function() {
      $(this).css(
        "background-image",
        "url('" + $(this).attr("img-cache-bg") + "')"
      );
    });
    $("[img-cache-src]").each(function() {
      $(this).attr("src", $(this).attr("img-cache-src"));
    });

	$(document).trigger('siteLoaded');
  }
);

function navTabActiveLineAnimated() {
  if ($(".types").length > 0) {
    $(".types").each(function() {
      var activeLink = $(this).find("a.active");
      var activeLinkLeftPosition = activeLink.offset().left;
      var activeLinkWidth = activeLink.width();
      var lineActiveItem = $(this).find(".header-line-active-item");

      lineActiveItem.width(activeLinkWidth);
      lineActiveItem.css("left", activeLinkLeftPosition);
    });
  } else if ($(".header ul").length > 0) {
    $(".header").each(function() {
      var activeLink = $(this).find("li.active");
      var activeLinkLeftPosition = activeLink.offset().left;
      var activeLinkWidth = activeLink.width();
      var lineActiveItem = $(this).find(".header-line-active-item");

      lineActiveItem.width(activeLinkWidth);
      lineActiveItem.css("left", activeLinkLeftPosition);
    });
  }
}

$(window).resize(function() {
  navTabActiveLineAnimated();
});

$(window).on("load", function() {
  navTabActiveLineAnimated();
});

var headerIsRelative;

if ($("#header_main").css("position") === "relative") {
  $("body").addClass("header-relative");
} else {
  $("body").removeClass("header-relative");
}

$(window).on("scroll", function() {
  var scrollTop = $(window).scrollTop();
  var header = $("#header_main");

  // console.log(scrollTop);
  // console.log(header);
  // console.log(header.height());

  if (scrollTop > header.height() && !$("body").hasClass("header-top-sticky")) {
    $("body").addClass("header-top-sticky");
    setTimeout(function() {
      $("body").addClass("header-top-anim-in");
    }, 50);
  } else if (
    scrollTop <= header.height() &&
    $("body").hasClass("header-top-sticky")
  ) {
    $("body").addClass("header-top-anim-out");

    setTimeout(function() {
      $("body").removeClass(
        "header-top-sticky header-top-anim-in header-top-anim-out"
      );
    }, 350);
  }
});

$(document).on("ready", function() {
  initScript();
  $("body").removeClass(function() {
    splitTextIntoWords();
    splitTextIntoWordsManualAnim();
    zoomImages();
    return "inanimate";
  });
});

function initScript() {
  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  if (iOS) {
    $("html").addClass("ios");
  }
  $(".anchorBtn").on("click", function(e) {
    e.preventDefault();
    var anchor = $(this).data("anchor");
    scrollToAnchor(anchor);
  });

  // $(".seeMore").on("click", function(e) {
  //   e.preventDefault();
  //   var trim = $(this).data("trim");
  //   $(".specsModal#" + trim).fadeIn();
  // });

  $(".dealer").on("click", function(e) {
    $(this)
      .find("input")
      .trigger("click");
    $(".dealer").removeClass("active");
    $(this).addClass("active");
  });

  $(".dealer input").on("click", function(e) {
    e.stopPropagation();
    $(".dealer").removeClass("active");
    $(this)
      .closest(".dealer")
      .addClass("active");
  });

  $(".moreDealer").on("click", function(e) {
    e.preventDefault();
    $(this)
      .closest("li")
      .find(".more")
      .slideToggle();
    $(this).toggleClass("active");
    var text = $(this).hasClass("active") ? "Ver menos" : "Ver más";
    $(this).text(text);
  });

  $(".file-input").on("click", function(e) {
    $(this)
      .find('input[type="file"]')
      .trigger("click");
  });

  $('.file-input input[type="file"]').on("click", function(e) {
    e.stopPropagation();
  });

  $('.file-input input[type="file"]').on("change", function(e) {
    var files = $(this)[0].files;
    if (files && files.length) {
      var name = files[0].name;
      $(this)
        .closest(".file-input")
        .find('input[type="text"]')
        .val(name);
    } else {
      $(this)
        .closest(".file-input")
        .find('input[type="text"]')
        .val("");
    }
  });

  $(".menu.mobile").on("click", function(e) {
    e.preventDefault();
    $("body").toggleClass("showMenu");
  });

  $(".trims li a").on("click", function(e) {
    e.preventDefault();
    $(this)
      .closest(".trims")
      .find("li")
      .removeClass("active");
    $(this)
      .closest("li")
      .addClass("active");
  });

  $("section.exterior .arrow.right").on("click", function(e) {
    console.log(e);
  });

  navTabActiveLineAnimated();
}


function splitTextIntoWords (baseDelay = 1){
	//console.log("Se ejecuto");
	//Get all the elements by class to split words into span
	var elem=document.getElementsByClassName('textAnimation');
	
	if(elem){
	//Loop through all the elements
	for(var i=0;i<elem.length;i++)
	{
		//console.log(elem[i].dataset.baseDelay); 
		baseDelayMultipleItems = elem[i].dataset.baseDelay;
		if(typeof elem[i].dataset.baseDelay=='undefined'){
			initDelay=3000;
		}else{
			initDelay=elem[i].dataset.baseDelay*1;
		}
		if(typeof elem[i].dataset.baseTotalTime=='undefined'){
			totalTime=2000;
		}else{
			totalTime=elem[i].dataset.baseTotalTime*1;
		}

		//Loop through all the textcontent and replace the innerhtml into words by a regex
		elem[i].innerHTML = elem[i].textContent.replace(/(.+?)([\S\,\.\!\?\;\:\)\(\[\]]+)/g, "<span class='wow word fadeInUpSmall' data-wow-duration='2.5s'>$&</span>");    
		
		//Get all the childrens created
		let children = elem[i].childNodes;
		
		//If there is only one the delay is set into 1 seg Else it will add the delay for each child
		if(children.length == 1){
			//console.log("Single children", baseDelay);
      if(children[0]){
			  children[0].dataset.wowDelay = (initDelay/1000)+'s';
      }
		}else{
			for(var c=0;c<children.length;c++)
			{                            
				//console.log("item delay:",(baseDelayMultipleItems*(c+1)/2))
				//children[c].dataset.wowDelay = initDelay+( (baseDelayMultipleItems*(c+1)/ (children.length == 2 ? 4:(c+children.length))))+'ms';        
        if(typeof children[c] != "undefined" && typeof children[c].dataset != "undefined"){
				  children[c].dataset.wowDelay = initDelay+( c*totalTime/children.length)+'ms';        
        }
			}
		}
   }
  }
}

function splitTextIntoWordsManualAnim (baseDelay = 1){
	//console.log("Se ejecuto");
	//Get all the elements by class to split words into span
	var elem=document.getElementsByClassName('textAnimationManual');
	
	if(elem){
	//Loop through all the elements
	for(var i=0;i<elem.length;i++)
	{
		//console.log(elem[i].dataset.baseDelay); 
		baseDelayMultipleItems = elem[i].dataset.baseDelay;
		if(typeof elem[i].dataset.baseDelay=='undefined'){
			initDelay=3000;
		}else{
			initDelay=elem[i].dataset.baseDelay*1;
		}
		if(typeof elem[i].dataset.baseTotalTime=='undefined'){
			totalTime=2000;
		}else{
			totalTime=elem[i].dataset.baseTotalTime*1;
		}

		//Loop through all the textcontent and replace the innerhtml into words by a regex
		elem[i].innerHTML = elem[i].textContent.replace(/(.+?)([\S\,\.\!\?\;\:\)\(\[\]]+)/g, "<span class='word'>$&</span>");    
		
		//Get all the childrens created
		let children = elem[i].childNodes;
		
		//If there is only one the delay is set into 1 seg Else it will add the delay for each child
		if(children.length == 1){
			//console.log("Single children", baseDelay);
      if(children[0]){
			  children[0].dataset.wowDelay = (initDelay/1000)+'s';
      }
		}else{
			for(var c=0;c<children.length;c++)
			{                            
				//console.log("item delay:",(baseDelayMultipleItems*(c+1)/2))
				//children[c].dataset.wowDelay = initDelay+( (baseDelayMultipleItems*(c+1)/ (children.length == 2 ? 4:(c+children.length))))+'ms';        
        if(typeof children[c] != "undefined" && typeof children[c].dataset != "undefined"){
				  children[c].dataset.wowDelay = initDelay+( c*totalTime/children.length)+'ms';        
        }
			}
		}
   }
  }
}

function zoomImages (){
  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({
    ease: "power1.inOut", 
    duration: 1
  });

  let zoomImages = gsap.utils.toArray(".zoomImage");

  zoomImages.forEach((image) => {
  gsap.fromTo(image, {scale: 1},    
      {
      scale: 1.2,
      duration: 0.5,
      scrollTrigger: {
        trigger: image,      
        //markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
        start: "center center", // when the top of the trigger hits the top of the viewport
        end: "bottom bottom", // end after scrolling 500px beyond the start
        scrub: 5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      }
    });
  });

  let zoomBGImages = gsap.utils.toArray(".imageBGZoom");

  let backgroundZoomInit;
  let backgroundZoomEnd;

  $(window).resize(function() {
  backgroundZoomInit = ($(window).width() > 1366) ? '100%' : '175%';
  backgroundZoomEnd = ($(window).width() > 1366) ? '125%' : '185%';
  })

  zoomBGImages.forEach((image) => {
  gsap.fromTo(image,{backgroundSize: backgroundZoomInit,},     
      {
      backgroundSize: backgroundZoomEnd,
      duration: 0.5,
      scrollTrigger: {
        trigger: image,      
        //markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
        start: "center center", // when the top of the trigger hits the top of the viewport
        end: "bottom bottom", // end after scrolling 500px beyond the start
        scrub: 5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      }
    });
  });



  let zoomBGHero = gsap.utils.toArray(".imageBGHero");

  zoomBGHero.forEach((image) => {
  gsap.fromTo(image,{backgroundSize: '103%',},     
      {
      backgroundSize: '110%',
      duration:1.5,
      scrollTrigger: {
        trigger: image,      
        //markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
        start: "center +=40%", // when the top of the trigger hits the top of the viewport
        end: "bottom bottom", // end after scrolling 500px beyond the start
        scrub: 5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      }
    });
  });

  
  $(window).scroll(function() {
    var elements = $(".zoom .zoomImageSlider");    
    
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    for(i = 0; i < elements.length; i++){
    
        var elemTop = $(elements[i]).offset().top;      

      
      var elemBottom = elemTop + $(elements[i]).height();      

      if(elemTop >= docViewTop){          
        $(elements[i]).css("background-size", "cover");                  
      }else{
        $(elements[i]).css("background-size", "scale(1.2)");          
      }
    }    
    var elementsWithChildrens = $(".zoom .zoomImageSlider");  

    for(i = 0; i < elementsWithChildrens.length; i++){

      var elemTop2 = $(elementsWithChildrens[i]).offset().top;      
            
      var elemBottom2 = elemTop2 + $(elementsWithChildrens[i]).height();      
      
      if(elemTop2 >= docViewTop){                              
          $(elementsWithChildrens[i]).css({
            '-webkit-transform' : 'scale(1)',
            '-moz-transform'    : 'scale(1)',
            '-ms-transform'     : 'scale(1)',
            '-o-transform'      : 'scale(1)',
            'transform'         : 'scale(1)'
          })                
      }else{
        $(elementsWithChildrens[i]).css({
          '-webkit-transform' : 'scale(1.2)',
          '-moz-transform'    : 'scale(1.2)',
          '-ms-transform'     : 'scale(1.2)',
          '-o-transform'      : 'scale(1.2)',
          'transform'         : 'scale(1.2)'
        })        
      }
    }    
  });
  
}